/**
 * DESCRIÇÃO DO IMÓVEL ALINHADA À ESQUERDA — licenças em que o `text-align: justify` padrão abre
 * "buracos" no texto.
 *
 * Gate por codsite (regra da casa: comportamento novo no código dos ~300 sites sai restrito à
 * licença que pediu). Para liberar mais uma licença, basta acrescentar o codsite aqui.
 *
 * Diagnóstico que originou (INC-0157, 25/09, cs2021 mtserraimoveis.com.br): a descrição no banco
 * está limpa (sem caractere invisível), mas é digitada sem espaço depois da vírgula
 * ("Cantos,na", "m²,sendo 25.59 de frente,30.74…") — viram "palavras" enormes e o justify estica
 * os poucos espaços da linha.
 */
export const CODSITES_DESCRICAO_ESQUERDA: ReadonlySet<number> = new Set<number>([2021]);

export function usaDescricaoEsquerda(codsite: unknown): boolean {
  const id = Number(codsite);
  return Number.isFinite(id) && id > 0 && CODSITES_DESCRICAO_ESQUERDA.has(id);
}
